import { fromJS } from 'immutable';
import moment from 'moment'
import { GET_ACTIVITIES, ADD_ACTIVITIES, UPDATE_ACTIVITIES, DEL_ACTIVITIES, GET_ACTIVITY_FORMATS, ADD_ACTIVITY_FORMATS, UPDATE_ACTIVITY_FORMATS, DEL_ACTIVITY_FORMATS, GET_CALENDARIO, ADD_EVENTO, UPDATE_EVENTO, DEL_EVENTO, ADD_PARTICIPANTE, UPDATE_PARTICIPANTE, DEL_PARTICIPANTE,GET_EVENTOS } from "../actions/constants";

const initialTodos = {
    calendario: [],
    eventos:[],
    activities_format: [],
    activities: [],
    contador: 0,
    contador_participantes: 0,
    tipos_label:["ALL","YOGA","SURF","SURFSKATE","TRANSPORT","DINNER"],
    //surf_activities: ["","WHITE WATER","GREEN WATER","COACHING","PRIVATE "],
    surf_activities: {
        0:"YOGA",
        1:"White water",
        2:"Green waves",
        3:"Coaching",
        4:"Private",
        5:"SurfSkate Private",
        6:"Underwave",
        24:"SurfSkate Group"
    },
    tipos:[{
        id:0,
        nombre:"ALL"
    },
    {
        id:1,
        nombre:"YOGA"
    },
    {
        id:2,
        nombre:"SURF"
    },
    {
        id:3,
        nombre:"SURFSKATE"
    },
    {
        id:4,
        nombre:"DINNER"
    },
    {
        id:5,
        nombre:"TRANSPORTATION"
    },
    {
        id:6,
        nombre:"MASSAGES"
    },
    {
        id:7,
        nombre:"RESTAURANT"
    }
    ]
};

const activities = (state = initialTodos, action) => {
    var newState = Object.assign({}, state);
    const datos = fromJS(newState)
    //console.log(action)
    switch (action.type) {
        case GET_ACTIVITY_FORMATS:
            const activitiesFormatNew = datos.updateIn(["activities_format"], (value) => action.payload);
            var countNew = activitiesFormatNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS();
        case GET_ACTIVITIES:
            const activitiesNew = datos.updateIn(["activities"], (value) => action.payload);
            var countNew = activitiesNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS();

        case GET_CALENDARIO:
            const calendarioNew = datos.updateIn(["calendario"], (value) => action.payload);
            //var countNew = calendarioNew.updateIn(["contador"], (value) => moment().unix());    
            return calendarioNew.toJS()
        case GET_EVENTOS:
            const eventosNew = datos.updateIn(["eventos"], (value) => action.payload);
            return eventosNew.toJS()
        case ADD_EVENTO:
            var countNew = datos.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case UPDATE_EVENTO:
            var countNew = datos.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        
            case DEL_EVENTO:
            var temp =Object.assign([],state.eventos)
            var pos = temp.findIndex((item) => item.id == action.payload)
            temp.splice(pos, 1);
            const eventosDelNew = datos.updateIn(["eventos"], (value) => temp);
            var countNew = eventosDelNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
            
        case ADD_PARTICIPANTE:
            var countNew = datos.updateIn(["contador_participantes"], (value) => moment().unix());
            return countNew.toJS()
        case UPDATE_PARTICIPANTE:
            var countNew = datos.updateIn(["contador_participantes"], (value) => moment().unix());
            return countNew.toJS()
            
        case DEL_PARTICIPANTE:
            var countNew = datos.updateIn(["contador_participantes"], (value) => moment().unix());
            return countNew.toJS()

        case ADD_ACTIVITIES:
            const activitiesAddNew = datos.updateIn(["activities"], (value) => action.payload);
            var countNew = activitiesAddNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case UPDATE_ACTIVITIES:
            const activitiesUpdateNew = datos.updateIn(["activities"], (value) => action.payload);
            var countNew = activitiesUpdateNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case DEL_ACTIVITIES:
            const activitiesDelNew = datos.updateIn(["activities"], (value) => action.payload);
            var countNew = activitiesDelNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case ADD_ACTIVITY_FORMATS:
            const activitiesAddFormatNew = datos.updateIn(["activities_format"], (value) => action.payload);
            var countNew = activitiesAddFormatNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case UPDATE_ACTIVITY_FORMATS:
            const activitiesUpdateFormatNew = datos.updateIn(["activities_format"], (value) => action.payload);
            var countNew = activitiesUpdateFormatNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        case DEL_ACTIVITY_FORMATS:
            const activitiesDelFormatNew = datos.updateIn(["activities_format"], (value) => action.payload);
            var countNew = activitiesDelFormatNew.updateIn(["contador"], (value) => moment().unix());
            return countNew.toJS()
        default:
            return state;
    }
}

export default activities